import LanguageList from '../components/language/List'
import LanguageCreate from '../components/language/Create'
import LanguageUpdate from '../components/language/Update'

export default [
  { name: 'LanguageList', path: '/languages/', component: LanguageList, props: { pageTitle: 'Language list' } },
  { name: 'LanguageCreate', path: '/languages/create', component: LanguageCreate, props: { pageTitle: 'Language Create' } },
  { name: 'LanguageUpdate', path: '/languages/edit/:id', component: LanguageUpdate, props: { pageTitle: 'Language Update' } }
]
